import React, { PureComponent } from 'react';
import { MdShare } from 'react-icons/md';
import { Translate } from 'react-localize-redux';
import styled from 'styled-components';

import Heading, { SubHeading } from '../../../components/heading';
import Modal from '../../../components/modal';
import SegmentedTranslate from '../../../hocs/segmented-translate';
import Section from '../section';
import sarahImages from './images';
/**
 * Puzzle photo
 */
import PUZZLE from './puzzle.jpg';

/**
 * Correct answer to puzzle
 */
const CORRECT_ANSWERS = ['しぶや', 'シブヤ', '渋谷'];

/**
 * Data for sharing if the puzzle is correct
 */
const SHARE_DESCRIPTION =
  '渋谷で開催中のAR謎解きゲーム『サラと謎のハッカークラブ』。新感覚の謎解きをご用意しています！✨ \n#サラ謎\n#謎解き\n#解けたらRT';

/**
 * Section wrapper
 */
const Background = styled.div`
  background: ${props => props.theme.primary};
`;

const Container = styled.div`
  padding: 0 1em;
`;

const Question = styled.p`
  font-size: 1.2em;
  font-weight: bold;
  text-align: center;
  margin: 2em 0 1.5em;
`;

const Image = styled.img`
  display: block;
  margin: 0 auto;
  width: 60%;
  max-width: 12em;
`;

const InputForm = styled.form`
  width: 100%;
  max-width: 24em;
  margin: 4em auto 0em;
  display: flex;
  justify-content: space-around;
`;

const Input = styled.input`
  color: #111111;
  background: white;
  border-radius: 0.3em;
  padding: 0 1.5em;
  margin-right: 1em;
  min-width: 0;
  height: 3em;
  border: none;
  &::placeholder {
    color: #b7b7b7;
  }
  &:focus {
    outline: none;
  }
`;

const SubmitButton = styled.button`
  background: #1e1f1f;
  border-radius: 0.3em;
  color: white;
  border: none;
  width: 8em;
`;

const Title = styled.h1`
  color: ${props => (props.isCorrect ? props.theme.primary : '#CA496D')};
  text-align: center;
`;

const Columns = styled.div`
  @media (max-width: 767px) {
    flex-direction: column;
    align-items: center;
  }
  padding: 0 2em;
  display: flex;
  justify-content: space-around;
`;

const Sarah = styled.picture`
  @media (max-width: 767px) {
    height: 10em;
  }
  @media (min-width: 768px) {
    margin-right: 2em;
  }
  img {
    height: 100%;
  }
`;

const Info = styled.div``;

const Text = styled.div`
  color: #111111;
  background: #f0f0f0;
  padding: 1em 2em;
  margin-bottom: 2em;
  > div {
    margin: 1em 0;
  }
  p {
    margin: 0;
  }
`;

const Button = styled.button`
  width: 100%;
  background: ${props => props.theme.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  outline: none;
  padding: 1em 0;
  color: white;
  border-radius: 0.2em;
  margin: 0 0 2em 0;
  > span {
    margin-left: 1em;
  }
`;

/**
 * Trial section of landing page
 * Allows user to play an example puzzle
 */
class Trial extends PureComponent {
  state = {
    canShare: false,
    value: '',
    correct: null
  };

  componentDidMount() {
    this.setState({
      canShare: navigator && navigator.share
    });
  }

  handleInputChange = ({ target }) => {
    this.setState({
      value: target.value
    });
  };

  handleFormSubmit = ev => {
    ev.preventDefault();
    this.setState({
      correct: CORRECT_ANSWERS.includes(this.state.value)
    });
  };

  handleModalClose = () => {
    this.setState({
      correct: null
    });
  };

  handleButtonClick = ev => {
    if (!this.state.correct) {
      return;
    }
    ev.stopPropagation();
    const shareData = {
      text: SHARE_DESCRIPTION,
      url: window.location.href
    };
    navigator.share(shareData).catch(err => {
      console.error('Could not share: ', err);
    });
  };

  render() {
    const answered = this.state.correct !== null;
    const modalType = this.state.correct ? 'correct' : 'incorrect';
    return (
      <Background>
        <Section>
          <Heading>TRIAL</Heading>
          <SubHeading>
            <Translate id="landingPage.trial.subtitle" />
          </SubHeading>
          <Container>
            <Question>
              <Translate id="landingPage.trial.question" />
            </Question>
            <Image src={PUZZLE} />
            <InputForm onSubmit={this.handleFormSubmit}>
              <Translate>
                {({ translate }) => (
                  <Input
                    onChange={this.handleInputChange}
                    placeholder={translate('landingPage.trial.placeholder')}
                    value={this.state.value}
                  />
                )}
              </Translate>
              <SubmitButton type="submit">
                <Translate id="landingPage.trial.submit" />
              </SubmitButton>
            </InputForm>
          </Container>
          {answered && (
            <Modal
              onClose={this.handleModalClose}
              style={{ maxWidth: '40em', padding: 0 }}
            >
              <Title isCorrect={this.state.correct}>
                <Translate id={`landingPage.trial.modals.${modalType}.title`} />
              </Title>
              <Columns>
                <Sarah>
                  <source
                    media="(min-width: 768px)"
                    srcSet={sarahImages[modalType]['desktop']}
                  />
                  <img alt="Sarah" src={sarahImages[modalType]['mobile']} />
                </Sarah>
                <Info>
                  <Text>
                    <div>
                      <p>
                        <Translate
                          id={`landingPage.trial.modals.${modalType}.1`}
                        />
                      </p>
                      <p>
                        <SegmentedTranslate
                          id={`landingPage.trial.modals.${modalType}.2`}
                        />
                      </p>
                    </div>
                    <div>
                      <SegmentedTranslate
                        id={`landingPage.trial.modals.${modalType}.3`}
                      />
                    </div>
                    <div>
                      <p>
                        <Translate
                          id={`landingPage.trial.modals.${modalType}.4`}
                        />
                      </p>
                      <p>
                        <SegmentedTranslate
                          id={`landingPage.trial.modals.${modalType}.5`}
                        />
                      </p>
                    </div>
                  </Text>
                  {this.state.canShare && (
                    <Button onClick={this.handleButtonClick}>
                      {this.state.correct && <MdShare size="1.5em" />}
                      <span>
                        <Translate
                          id={`landingPage.trial.modals.${modalType}.button`}
                        />
                      </span>
                    </Button>
                  )}
                </Info>
              </Columns>
            </Modal>
          )}
        </Section>
      </Background>
    );
  }
}

export default Trial;
